import { createFileRoute } from '@tanstack/react-router';
import { requireDashboardFeature } from '@/features/dashboard/guard';
import { MyTasksPage } from '@/features/dashboard/my-tasks-page';
import { parseMyTasksSearch } from '@/features/dashboard/my-tasks-view';

/**
 * DASH-01: all open tasks assigned to me, across projects (internal and external users).
 * Filters, sorting and grouping live in the URL.
 */
export const Route = createFileRoute('/_app/my-tasks')({
  validateSearch: (raw: Record<string, unknown>) => parseMyTasksSearch(raw),
  beforeLoad: ({ context }) => requireDashboardFeature(context.queryClient),
  component: RouteComponent,
});

function RouteComponent() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <MyTasksPage
      search={search}
      onSearchChange={(next) => {
        void navigate({ search: next, replace: true });
      }}
    />
  );
}
